import styled, { css } from 'styled-components';
import Typography from '../../typography';
import { pxToRem } from '../../../design-tokens/style-utilities';
/* TODO: use design-tokens when figma has been updated */
export const SPINNER_SIZE = {
    small: 20,
    medium: 40,
    large: 80,
};
/**
 * Spinner Container
 */
export const spinnerContainerStyles = ({ theme, $inline, }) => css `
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['200'])};

	${$inline &&
    css `
		display: inline-block;
		margin: ${pxToRem(theme.spacing['100'])};
		gap: 0;
	`}
`;
export const SpinnerContainer = styled.div `
	${spinnerContainerStyles}
`;
/**
 * Spinner SVG
 */
export const spinnerSVGStyles = ({ $size }) => css `
	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	width: ${pxToRem(SPINNER_SIZE[$size])};
	height: ${pxToRem(SPINNER_SIZE[$size])};
	transform-origin: center;
	animation: spin 0.75s linear infinite;
`;
export const SpinnerSVG = styled.svg `
	${spinnerSVGStyles}
`;
/**
 * Spinner SVG circle
 */
export const spinnerSVGCirlceStyles = ({ theme, $position, $inverted, }) => css `
	fill: ${$position === 'foreground' ? theme.colors.informative.fillSpinner : 'white'};

	${$inverted &&
    css `
		fill: ${$position === 'foreground'
        ? theme.colors.blanc.fillSpinner
        : theme.colors.base.iconIllustrative};
	`}
`;
export const SpinnerSVGCircle = styled.circle `
	${spinnerSVGCirlceStyles}
`;
/**
 * Spinner Text
 */
export const spinnerTextStyles = () => css `
	margin: 0;
`;
export const SpinnerText = styled(Typography).attrs(() => ({
    variant: 'body-text',
})) `
	${spinnerTextStyles}
`;
